import dragon1 from "../assets/images/avatars/dragon_1.png";
import dragon2 from "../assets/images/avatars/dragon_2.png";
// Avatar utility functions
import person1 from "../assets/images/avatars/person_1.png";
import person2 from "../assets/images/avatars/person_2.png";
import person3 from "../assets/images/avatars/person_3.png";

// Available avatar images
export const avatarImages = [person1, person2, person3, dragon1, dragon2];

/**
 * Get saved avatar URL from localStorage (set by AvatarEditor)
 * @returns {string|null}
 */
const getSavedAvatarUrl = () => {
  try {
    const raw = localStorage.getItem("ayg_avatar");
    if (raw) {
      const parsed = JSON.parse(raw);
      return parsed.url ?? null;
    }
  } catch {
    // ignore
  }
  return null;
};

/**
 * Get a user's avatar image based on their data
 * @param {Object} userData - User data object
 * @param {string} userData.avatar - User's selected avatar (if any)
 * @returns {string} Avatar image URL
 */
export const getUserAvatarImage = userData => {
  // Check for custom avatar saved via AvatarEditor
  const savedUrl = getSavedAvatarUrl();
  if (savedUrl) return savedUrl;

  // If user has a specific avatar selected, use it
  if (userData?.avatar && avatarImages.includes(userData.avatar)) {
    return userData.avatar;
  }

  // Check if we have a session avatar stored
  const sessionAvatar = sessionStorage.getItem("userSessionAvatar");
  if (sessionAvatar && avatarImages.includes(sessionAvatar)) {
    return sessionAvatar;
  }

  // Otherwise, select a random avatar for this session and store it
  const randomIndex = Math.floor(Math.random() * avatarImages.length);
  const selectedAvatar = avatarImages[randomIndex];
  sessionStorage.setItem("userSessionAvatar", selectedAvatar);

  return selectedAvatar;
};

/**
 * Get user initials as fallback
 * @param {Object} userData - User data object
 * @returns {string} User initials
 */
export const getUserInitials = userData => {
  if (!userData) {
    return "";
  }

  const firstName = userData.given_name || userData.firstName || "";
  const lastName = userData.family_name || userData.lastName || "";

  return (firstName[0] || "") + (lastName[0] || "");
};

/**
 * Clear session avatar (call on logout)
 */
export const clearSessionAvatar = () => {
  sessionStorage.removeItem("userSessionAvatar");
};
